import { get } from 'epics/ajax';
import { contextPath as historyContextPath } from 'util/history';
import { Observable } from 'epics/rxjs';
import { trackError } from 'util/analytics';
import type { ApolloErrorResponse } from 'epics/model/types';
import { APOLLO_CONTEXT_ROOT, APOLLO_STARGATE_CONTEXT_ROOT } from 'rest/constants';
import type { AjaxError } from 'rxjs/observable/dom/AjaxObservable';
import { isApolloStargatePathEnabled } from 'feature-flags';
import { getMeta } from 'util/meta';
export interface FetchCategoryRequest {
    projectId: number;
    contextPath?: string;
    apolloPath?: string;
}
export interface Category {
    id: string;
    name: string;
    description: string;
}
export interface CategoryError {
    error: ApolloErrorResponse;
}

export interface NewCategoriesResponse {
    categories: Category[];
    categoriesSupported: boolean;
}

export type CategoriesResponse = Category[] | NewCategoriesResponse;

const mapApolloErrorResponse = (error: AjaxError): ApolloErrorResponse => {
    return { statusCode: error.status, errorKey: '', errorMessage: error.message || '' };
};

export const fetchCategories = ({
    projectId,
    contextPath = historyContextPath,
    apolloPath = APOLLO_CONTEXT_ROOT,
}: FetchCategoryRequest) => {
    const uri = isApolloStargatePathEnabled()
        ? // TypeScript upgrade (v4.4.3). Please correct when you revisit this code. Please correct when this code is revisited.
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          `${contextPath}${APOLLO_STARGATE_CONTEXT_ROOT}/${getMeta('activation-id')}/api/project/${projectId}/category`
        : `${contextPath}${apolloPath}/api/project/${projectId}/category`;
    return get(uri, { 'Content-Type': 'application/json' })
        .map(({ response }) => response)
        .catch((e: AjaxError) => {
            trackError('categories.fetch.all.failed', {}, e);
            return Observable.throw(mapApolloErrorResponse(e));
        });
};
